import { Service, inject } from '@angular/core'
import {
  AuthLoginBody,
  AuthRegisterBody,
  AuthRegisterEntityBody,
  LoginResponse,
  ResetPasswordBody,
  SetNewPasswordBody,
  SuccessResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class AuthApiService {
  private readonly api = inject(ApiService)

  signup(body: AuthRegisterBody, init?: RequestInit) {
    return this.api.fetchJson<LoginResponse>(`auth/signup`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  signin(body: AuthLoginBody, init?: RequestInit) {
    return this.api.fetchJson<LoginResponse>(`auth/signin`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  registerEntity(body: AuthRegisterEntityBody, init?: RequestInit) {
    return this.api.fetchJson<LoginResponse>(`auth/register-entity`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  resetPassword(body: ResetPasswordBody, init?: RequestInit) {
    return this.api.fetchJson<SuccessResponse>(`auth/reset-password`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  setNewPassword(body: SetNewPasswordBody, init?: RequestInit) {
    return this.api.fetchJson<SuccessResponse>(`auth/set-new-password`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
